<template>
    <div class="row">
        <div class="col-12 mb-4 d-flex flex-row align-items-center justify-content-between">
            <h1 class="mb-0">{{ $t('group-types') }}</h1>
            <router-link class="btn btn-primary" to="/settings/grouptypes/0">{{ $t('new') }}</router-link>
        </div>
        <div class="col-12 mb-4">
            <Table 
                :data="data"
                :cols="cols"
                :loading="loading"
                @selectItem="type => $router.push(`/settings/grouptypes/${type.id}`)"
            >
                <template v-slot:header>
                    <div class="list-group-item d-flex flex-row align-items-center">
                        <SelectInput 
                            v-model="filters.published" 
                            :nullLabel="$t('all')" 
                            :options="{ 0: $t('draft'), 1: $t('published') }"
                            :indexIsValue="true"
                            :label="$t('status')"
                            class="mb-0"
                            style="min-width: 200px"
                        />
                    </div>
                </template>
            </Table>
        </div>
    </div>
</template>

<script>
import Table from "src/components/Table/Table.vue"
import SelectInput from "src/components/Inputs/SelectInput.vue"

export default {
    components: {
        Table,
        SelectInput,
    },
    mounted() {
        this.fetchGroupTypes().then(() => {
            this.loading = false
        })
    },
    data() {
        return {
            loading: true,
            cols: [
                { key: 'title', heading: this.$t('title'), size: 9 },
                { key: 'published', heading: this.$t('status'), size: 3, cb: (el) => Number(el.published) ? this.$t('published') : this.$t('draft') },
            ],
            groupTypes: [],
            filters: {
                published: null,
            },
        }
    },
    methods: {
        fetchGroupTypes() {
            this.$store.commit('showBlockingSpinner')

            return this.$cfetch(`${this.$settings.APIBaseURL}/grouptypes/all`, {
                method: 'GET',
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error()

                this.groupTypes = res.results
            }).catch(err => {
                console.error(err)
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-fetching-group-types'),
                    confirmCallBack: () => {
                        this.$router.replace('/settings')
                    }
                })
            }).finally(() => {
                this.$store.commit('hideBlockingSpinner')
            })
        }
    },
    computed: {
        data() {
            if (this.filters.published === null) return this.groupTypes
            return this.groupTypes.filter(type => type.published === this.filters.published)
        }
    }
}
</script>